function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Simple className utility without external dependencies
export var cn = function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return inputs.filter(Boolean).map(function (input) {
    if (typeof input === "string") return input;
    if (_typeof(input) === "object") {
      return Object.keys(input).filter(function (key) {
        return input[key];
      }).join(" ");
    }
    return "";
  }).join(" ").trim();
};
export var currencyToIndianRsWord = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  notation: "compact",
  compactDisplay: "long"
});